import { createSelectorHooks } from "auto-zustand-selectors-hook";
import { produce } from "immer";
import { create } from "zustand";

import { ILayoutStore } from "@/types";

const useLayoutStoreBase = create<ILayoutStore>((set) => ({
  collapsed: false,
  title: null,
  rightCta: null,
  isSearchOpened: false,
  isLoader: false,
  setCollapsed: (value) => {
    set(
      produce<ILayoutStore>((state) => {
        state.collapsed = value;
      }),
    );
  },
  setTitle: (title) => {
    set(
      produce<ILayoutStore>((state) => {
        state.title = title;
      }),
    );
  },
  setRightCta: (node) => {
    set(
      produce<ILayoutStore>((state) => {
        state.rightCta = node;
      }),
    );
  },
  isSearchOpenedSet: (val) => {
    set(
      produce<ILayoutStore>((state) => {
        state.isSearchOpened = val;
      }),
    );
  },
  setIsLoader: (val) => {
    set(
      produce<ILayoutStore>((state) => {
        state.isLoader = val;
      }),
    );
  },
}));

const useLayoutStore = createSelectorHooks(useLayoutStoreBase);

export default useLayoutStore;
